export default class MediaQuery {
    static UpSm = window.matchMedia('(min-width: 640px)')
    static UpMd = window.matchMedia('(min-width: 992px)')
}
